import { FETCH_MONITORED_DOCUMENT_COMPARE } from '../actions/MonitoredDocumentActions';

// INITIALIZE STATE
const initialState = {
    monitoredDocumentCompare: null,
    fetching: false,
    fetched: false,
    failed: false,
};

// REDUCER
export const MonitoredDocumentCompareReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MONITORED_DOCUMENT_COMPARE}_PENDING`:
            return {
                ...state,
                monitoredDocumentCompare: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_COMPARE}_FULFILLED`:
            return {
                ...state,
                monitoredDocumentCompare: action.payload,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_COMPARE}_REJECTED`:
            return {
                ...state,
                monitoredDocumentCompare: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
